import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setAction } from 'redux/actions/projectConfig';
import BuildInputs from '../../shared/widgets/BuildInputs';
import Accordion from './../Accordion';

export default function CustomizeSection(props) {
  const { customizeOptions, lang, editorConfig, defaultTab, padding } = props;
  const { activeBasicTab, tab } = useSelector((state) => state.projectConfig);
  const Container = props.container ?? Accordion;
  const dispatch = useDispatch();

  useEffect(() => {
    changeActiveBasicTab(defaultTab);
    return () => {
      switchActiveBasicTab('');
    };
  }, []);

  const changeActiveBasicTab = (tab) => dispatch(setAction({ activeBasicTab: tab }));
  const switchActiveBasicTab = (tab) => {
    if (tab === activeBasicTab) tab = '';
    changeActiveBasicTab(tab);
  };

  useEffect(() => {
    // During the resize event from the data tab, Highcharts removes all the text from the chart
    // due to the responsive rules set up by us, this means we cannot pull the correct values.
    // Close the tab so we have time for the resize event to complete before pulling.
    if (tab === 'data' && activeBasicTab === 'option.cat.text') {
      changeActiveBasicTab('');
    }
  }, [tab]);

  return (
    <>
      {Object.keys(customizeOptions || {}).map((key) => {
        const option = (customizeOptions || {})[key];
        return (
          <Container
            accordionClasses="list-dropdown bg-ev-grey"
            childrenClasses="relative flex flex-col rounded mx-6 py-2 pb-6"
            key={key}
            selected={activeBasicTab === key}
            onClick={() => switchActiveBasicTab(key)}
            headerText={lang.entries[key]}
            useKey={key}
            padding={padding}
          >
            {option.map((section) => {
              return (
                <BuildInputs
                  section={section}
                  parentKey={key}
                  key={key}
                  editorConfig={editorConfig?.customizer?.availableSettings}
                />
              );
            })}
          </Container>
        );
      })}
    </>
  );
}
